import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import VkVideoPlayer from "@components/Common/VkVideoPlayer";
import { DevModal } from "@components/Helpers";

import VkVideoStatus from "./VKVideoStatus";

function VKVideoPlayerModal({ data }) {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const handleShow = () => setShow(true);

    return (
        <>
            {data && data?.thumbs?.url_small && (
                <img
                    onClick={handleShow}
                    className="img-thumbnail dev-listing-img"
                    src={data?.thumbs.url_small}
                    alt="image"
                    style={{ cursor: "pointer" }}
                />
            )}

            <DevModal
                show={show}
                onHide={handleClose}
                body={
                    <>
                        <VkVideoStatus data={data} />
                        {data && <VkVideoPlayer data={data} height="300" />}
                    </>
                }
                footer={
                    <Button variant="light" onClick={handleClose}>
                        {t("Закрыть")}
                    </Button>
                }
            />
        </>
    );
}

export default VKVideoPlayerModal;
